import { useCallback } from 'react'

import { Box, Divider, Stack } from "@mui/material"

import { ColumnSplitter } from 'components/controls/splitter'
import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'
import { SearchWordField } from 'components/controls/searchWordField'

import { SisetuResult } from "interface/sisetu"

import { useSisetuPreview } from '../../container'

import { useSisetusResearchPage } from './container'
import { ResearchList } from './components/researchList'
import { ResearcherTable } from './components/researcherTable'
import { ResearchBarGraph } from './components/researchBarGraph'
import { ValueSpan } from 'components/controls/valueSpan'
import { numberFormat } from 'shared/util'

type SisetuPreviewResearchPageProps = {
  sisetu: SisetuResult
  container: ReturnType<typeof useSisetuPreview>
}
export const SisetuPreviewResearchPage = ({
  sisetu,
  container: {
    onResearchOpen
  }
}: SisetuPreviewResearchPageProps) => {
  const container = useSisetusResearchPage({ sisetuCode: sisetu.sisetuCode })
  const {
    searchWord, setSearchWord,
		selectedYear, setSelectedYear,
		selectedResearcher, setSelectedResearcher,
		loading, error,
		projects, researchers, yearsStats
  } = container

  const onSelectedProject = useCallback(
    (projectKey: string) => {
      const project = projects.find(project => project.projectKey === projectKey)
      if (!project) return
      onResearchOpen(project, projects)
    },
    [onResearchOpen, projects]
  )
  return (
    <>
      {loading ? <Loading/> :
       error ? <ErrorBlock error={error} padding={1}/> : (
        <ColumnSplitter initialSizes={[66, 34]}>
          <Stack
            direction='column'
            height='100%'
            position='relative'
            overflow='hidden'
          >
            <Stack
              direction="column"
              flexShrink={0}
              padding={1}
            >
              <Stack direction="row" spacing={1} alignItems="center" justifyContent='flex-end'>
                <ValueSpan text={numberFormat(projects.length)} prefix='課題数' suffix='件'/>
                <ValueSpan text={numberFormat(projects.reduce((acc, p) => acc + p.totalCost, 0))} prefix='研究費計' suffix='円'/>
                <ValueSpan text={numberFormat(researchers.length)} prefix='研究者' suffix='人'/>
              </Stack>

              <Stack
                flexShrink={0}
                overflow="hidden"
                direction="row"
                justifyContent="center"
              >
                <Box width="100%" maxWidth={"60rem"}>
                  <ResearchBarGraph
                    yearsStats={yearsStats}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    height={150}
                  />
                </Box>
              </Stack>
            </Stack>

            <Divider/>

            <ResearcherTable
              flexGrow={1}
              overflow='hidden'
              researchers={researchers}
              selectedResearcher={selectedResearcher}
              setSelectedResearcher={setSelectedResearcher}
            />
          </Stack>

          <Stack
            direction='column'
            height='100%'
            overflow='hidden'
          >
            <Box
              flexShrink={0}
              padding={1}
            >
              <SearchWordField
                id='search-word-trial'
                searchWord={searchWord}
                onChangeSearchWord={setSearchWord}
                fullWidth
              />
            </Box>
            <Divider/>
            <Box
              flexGrow={1}
              overflow='auto'
              position='relative'
            >
              <ResearchList
                projects={projects}
                onSelChangeProject={onSelectedProject}
              />
            </Box>
          </Stack>
        </ColumnSplitter>
      )}
    </>
  )
}